import type { Modals } from "@kiwicom/frontend-common/consts/modals"

import type {
  BookingClearErrorAction,
  BookingClearSuccessAction,
  BookingSetModalOpenAction,
  BookingOpenRefundScheduleChangeModalAction,
} from "./types"
import { CLEAR_ERROR, CLEAR_SUCCESS, SET_MODAL_OPEN, SET_REFUND_SHOT_MODAL_OPEN } from "./consts"

export const openModalAction = (
  modal: Modals,
  additionalTrackingProps?: Record<string, string>,
): BookingSetModalOpenAction => ({
  type: SET_MODAL_OPEN,
  modal,
  // @ts-expect-error: Flow to TS migration.
  _track: { ...additionalTrackingProps, modal },
})
export const openRefundScheduleChangeModalAction = (): BookingOpenRefundScheduleChangeModalAction => ({
  type: SET_REFUND_SHOT_MODAL_OPEN,
})
export const closeModalAction = (): BookingSetModalOpenAction => ({
  type: SET_MODAL_OPEN,
  modal: null,
})
export const clearErrorAction = (): BookingClearErrorAction => ({
  type: CLEAR_ERROR,
})
export const clearSuccessAction = (): BookingClearSuccessAction => ({
  type: CLEAR_SUCCESS,
})
